import TaskManager from './pages/TaskManager';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import CustomerList from './pages/CustomerList';
import AddCustomer from './pages/AddCustomer';
import DocketList from './pages/DocketList';
import CreateDocket from './pages/CreateDocket';
import DocketPrint from './pages/DocketPrint';
import DocketLabelPrint from './pages/DocketLabelPrint';
import CargoArrivalNoticeForm from './pages/documents/CargoArrivalNoticeForm';
import CANPrint from './pages/documents/CANPrint';
import SeaCargoArrivalNoticeForm from './pages/documents/SeaCargoArrivalNoticeForm';
import SeaDeliveryOrderForm from './pages/documents/SeaDeliveryOrderForm';
import SeaFreightCertificateForm from './pages/documents/SeaFreightCertificateForm';
import SeaMtDocumentList from './pages/documents/SeaMtDocumentList';
import SeaMtDocumentForm from './pages/documents/SeaMtDocumentForm';
import LrReceiptList from './pages/documents/LrReceiptList';
import LrReceiptForm from './pages/documents/LrReceiptForm';
import VendorList from './pages/fleet/VendorList';
import AddVendor from './pages/fleet/AddVendor';
import VehicleTypeMaster from './pages/fleet/VehicleTypeMaster';
import VendorVehicleList from './pages/fleet/VendorVehicleList';
import VendorVehicleForm from './pages/fleet/VendorVehicleForm';
import DriverList from './pages/fleet/DriverList';
import AddDriver from './pages/fleet/AddDriver';
import DriverLedger from './pages/fleet/DriverLedger';
import BookingDispatchBoard from './pages/fleet/BookingDispatchBoard';

import TripList from './pages/fleet/TripList';
import AddTrip from './pages/fleet/AddTrip';
import TripDetail from './pages/fleet/TripDetail';
import TripPrint from './pages/fleet/TripPrint';
import BookingRequestList from './pages/booking/BookingRequestList';
import BookingRequestForm from './pages/booking/BookingRequestForm';
import BookingEmbed from './pages/booking/BookingEmbed';
import DeliveryOrderForm from './pages/documents/DeliveryOrderForm';
import DOPrint from './pages/documents/DOPrint';
import FreightCertificateForm from './pages/documents/FreightCertificateForm';
import AirWaybillForm from './pages/documents/AirWaybillForm';
import AirWaybillSVGPrint from './pages/documents/AirWaybillSVGPrint';
import AWBPreview from './pages/documents/AWBPreview';
import TrackingForm from './pages/TrackingForm';
import StoreDocuments from './pages/StoreDocuments';
import ManifestList from './pages/AirManifests/ManifestList';
import ManifestForm from './pages/AirManifests/ManifestForm';
import LiftingAdviceForm from './pages/LiftingAdvice/LiftingAdviceForm';
import Settings from './pages/Settings';
import CompanyManagement from './pages/CompanyManagement';
import UserManagement from './pages/UserManagement';
import DriveSettings from './pages/DriveSettings';
import AttrestrSettings from './pages/settings/AttrestrSettings';
import SmsSettings from './pages/settings/SmsSettings';
import WhatsappSettings from './pages/settings/WhatsappSettings';
import FmsSettings from './pages/settings/FmsSettings';
import GlobalDocketSettings from './pages/settings/GlobalDocketSettings';
import ActivityLog from './pages/settings/ActivityLog';
import RolePermissions from './pages/settings/RolePermissions';
import AiSettings from './pages/settings/AiSettings';
import DriveFileBrowser from './pages/DriveFileBrowser';
import EmailSettings from './pages/EmailSettings';
import AddCompany from './pages/AddCompany';
import AddUser from './pages/AddUser';
import LocationList from './pages/LocationList';
import AddLocation from './pages/AddLocation';
import CarrierList from './pages/CarrierList';
import AddCarrier from './pages/AddCarrier';
import AgentList from './pages/AgentList';
import CustodianList from './pages/CustodianList';
import AddAgent from './pages/AddAgent';
import EstimateList from './pages/estimates/EstimateList';
import EstimateForm from './pages/estimates/EstimateForm';
import EstimatePrint from './pages/estimates/EstimatePrint';
import InventoryList from './pages/inventory/InventoryList';
import InventoryForm from './pages/inventory/InventoryForm';
import ReportsLanding from './pages/reports/ReportsLanding';
import InventoryReports from './pages/reports/InventoryReports';
import FleetReports from './pages/reports/FleetReports';
import DocketReports from './pages/reports/DocketReports';
import BookingReports from './pages/reports/BookingReports';
import CustomerLogin from './pages/CustomerLogin';
import CustomerDashboard from './pages/customer-portal/CustomerDashboard';
import CustomerDockets from './pages/customer-portal/CustomerDockets';
import CustomerRequestBooking from './pages/customer-portal/CustomerRequestBooking';
import CustomerBookingRequests from './pages/customer-portal/CustomerBookingRequests';
import CustomerEstimates from './pages/customer-portal/CustomerEstimates';
import CustomerDocketDetail from './pages/customer-portal/CustomerDocketDetail';
import CustomerPortalKyc from './pages/customer-portal/CustomerPortalKyc';
import PublicKycOnboarding from './pages/PublicKycOnboarding';
import PublicVendorKycOnboarding from './pages/PublicVendorKycOnboarding';
import CustomerProfile from './pages/customers/CustomerProfile';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <Router>
      <Toaster />
      <Routes>
        {/* Customer Portal Routes (Dedicated Client Layout) */}
        <Route path="/customer-login" element={<CustomerLogin />} />
        <Route path="/customer-portal/dashboard" element={<CustomerDashboard />} />
        <Route path="/customer-portal/dockets" element={<CustomerDockets />} />
        <Route path="/customer-portal/request-booking" element={<CustomerRequestBooking />} />
        <Route path="/customer-portal/booking-requests" element={<CustomerBookingRequests />} />
        <Route path="/customer-portal/estimates" element={<CustomerEstimates />} />
        <Route path="/customer-portal/docket/:id" element={<CustomerDocketDetail />} />
        <Route path="/customer-portal/kyc" element={<CustomerPortalKyc />} />
        <Route path="/kyc-onboarding/:token" element={<PublicKycOnboarding />} />
        <Route path="/vendor-kyc-onboarding/:token" element={<PublicVendorKycOnboarding />} />
        
        {/* Public / Staff Login Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="/dashboard/customers" element={<CustomerList />} />
          <Route path="/dashboard/customers/add" element={<AddCustomer />} />
          <Route path="/dashboard/customers/edit/:id" element={<AddCustomer />} />
          <Route path="settings/*" element={<Navigate to="/settings/companies" replace />} />
        </Route>
        {/* Shortcut routes */}
        <Route path="/customers" element={<DashboardLayout />}>
          <Route index element={<CustomerList />} />
          <Route path="add" element={<AddCustomer />} />
          <Route path="edit/:id" element={<AddCustomer />} />
          <Route path="view/:id" element={<CustomerProfile />} />
        </Route>
        {/* Dockets routes */}
        <Route path="/dockets" element={<DashboardLayout />}>
          <Route index element={<DocketList />} />
          <Route path="create" element={<CreateDocket />} />
          <Route path="edit/:id" element={<CreateDocket />} />
          <Route path="view/:id" element={<CreateDocket />} />
          <Route path="print/:id" element={<DocketPrint />} />
          <Route path=":docketId/can-print" element={<CANPrint />} />
          <Route path=":docketId/do-print" element={<DOPrint />} />
          <Route path=":docketId/cargo-arrival-notice" element={<CargoArrivalNoticeForm />} />
          <Route path=":docketId/sea-cargo-arrival-notice" element={<SeaCargoArrivalNoticeForm />} />
          <Route path=":docketId/sea-delivery-order" element={<SeaDeliveryOrderForm />} />
          <Route path=":docketId/sea-freight-certificate" element={<SeaFreightCertificateForm />} />
          <Route path=":docketId/sea-mt-documents" element={<SeaMtDocumentList />} />
          <Route path=":docketId/sea-mt-documents/new" element={<SeaMtDocumentForm />} />
          <Route path=":docketId/sea-mt-documents/:mtDocId/edit" element={<SeaMtDocumentForm />} />
          <Route path=":docketId/sea-mt-documents/:mtDocId/print" element={<SeaMtDocumentForm />} />
          <Route path=":docketId/lr-receipts" element={<LrReceiptList />} />
          <Route path=":docketId/lr-receipts/new" element={<LrReceiptForm />} />
          <Route path=":docketId/lr-receipts/:lrId/edit" element={<LrReceiptForm />} />
          <Route path=":docketId/lr-receipts/:lrId/print" element={<LrReceiptForm />} />
          <Route path=":docketId/delivery-order" element={<DeliveryOrderForm />} />
          <Route path=":docketId/freight-certificate" element={<FreightCertificateForm />} />
          <Route path=":docketId/air-waybill" element={<AirWaybillForm />} />
          <Route path=":docketId/house-air-waybill" element={<AirWaybillForm />} />
          <Route path=":docketId/tracking" element={<TrackingForm />} />
          <Route path=":docketId/store-documents" element={<StoreDocuments />} />
          <Route path=":docketId/air-manifests" element={<ManifestList />} />
          <Route path=":docketId/lifting-advice" element={<LiftingAdviceForm />} />
        </Route>
        {/* Air Manifest routes */}
        <Route path="/air-manifests" element={<DashboardLayout />}>
          <Route index element={<ManifestList />} />
          <Route path="new" element={<ManifestForm />} />
          <Route path=":manifestId/edit" element={<ManifestForm />} />
        </Route>
        {/* Lifting Advice routes */}
        <Route path="/lifting-advice" element={<DashboardLayout />}>
          <Route index element={<LiftingAdviceForm />} />
        </Route>
                {/* TMS / Task Management route */}
        <Route path="/tasks" element={<DashboardLayout />}>
          <Route index element={<TaskManager />} />
        </Route>
        {/* Dispatch Control Tower route */}
        <Route path="/dispatch" element={<DashboardLayout />}>
          <Route index element={<BookingDispatchBoard />} />
        </Route>
                {/* Vendor routes */}
        <Route path="/vendors" element={<DashboardLayout />}>
          <Route index element={<VendorList />} />
          <Route path="add" element={<AddVendor />} />
          <Route path="edit/:id" element={<AddVendor />} />
          <Route path="view/:id" element={<AddVendor />} />
        </Route>
        {/* Fleet Management routes */}
        <Route path="/fleet" element={<DashboardLayout />}>
          <Route path="vendors" element={<VendorList />} />
          <Route path="vendors/add" element={<AddVendor />} />
          <Route path="vendors/edit/:id" element={<AddVendor />} />
          <Route path="vendors/view/:id" element={<AddVendor />} />
          <Route path="vehicle-types" element={<VehicleTypeMaster />} />
          <Route path="vehicles" element={<VendorVehicleList />} />
          <Route path="vehicles/add" element={<VendorVehicleForm />} />
          <Route path="vehicles/edit/:id" element={<VendorVehicleForm />} />
          <Route path="drivers" element={<DriverList />} />
          <Route path="drivers/add" element={<AddDriver />} />
          <Route path="drivers/edit/:id" element={<AddDriver />} />
          <Route path="driver-ledger" element={<DriverLedger />} />
          <Route path="trips" element={<TripList />} />
          <Route path="dispatch" element={<BookingDispatchBoard />} />

          <Route path="trips/add" element={<AddTrip />} />
          <Route path="trips/edit/:id" element={<AddTrip />} />
          <Route path="trips/view/:id" element={<TripDetail />} />
        </Route>
        {/* Booking Request routes */}
        <Route path="/booking" element={<DashboardLayout />}>
          <Route index element={<BookingRequestList />} />
          <Route path="add" element={<BookingRequestForm />} />
          <Route path="edit/:id" element={<BookingRequestForm />} />
        </Route>
        <Route path="/bookings" element={<Navigate to="/booking" replace />} />
        <Route path="/bookings/new" element={<Navigate to="/booking/add" replace />} />
        <Route path="/bookings/add" element={<Navigate to="/booking/add" replace />} />
        {/* Embeddable booking form (public, no sidebar) */}
        <Route path="/booking/embed" element={<BookingEmbed />} />
        {/* Location Master routes */}
        <Route path="/locations" element={<Navigate to="/settings/locations" replace />} />
        {/* Carrier Master routes */}
        <Route path="/carriers" element={<Navigate to="/settings/carriers" replace />} />
        {/* Documents — Drive File Browser */}
        <Route path="/documents" element={<DashboardLayout />}>
          <Route index element={<DriveFileBrowser />} />
        </Route>
        <Route path="/settings" element={<DashboardLayout />}>
          <Route element={<Settings />}>
            <Route index element={<Navigate to="companies" replace />} />
            <Route path="companies" element={<CompanyManagement />} />
            <Route path="companies/add" element={<AddCompany />} />
            <Route path="companies/edit/:id" element={<AddCompany />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="users/add" element={<AddUser />} />
            <Route path="users/edit/:id" element={<AddUser />} />
            <Route path="locations" element={<LocationList />} />
            <Route path="locations/add" element={<AddLocation />} />
            <Route path="locations/edit/:id" element={<AddLocation />} />
            <Route path="carriers" element={<CarrierList />} />
            <Route path="carriers/add" element={<AddCarrier />} />
            <Route path="carriers/edit/:id" element={<AddCarrier />} />
            <Route path="agents" element={<AgentList />} />
            <Route path="agents/add" element={<AddAgent />} />
            <Route path="agents/edit/:id" element={<AddAgent />} />
            <Route path="custodians" element={<CustodianList />} />
            <Route path="drive" element={<DriveSettings />} />
          <Route path="email" element={<EmailSettings />} />
          <Route path="attestr" element={<AttrestrSettings />} />
          <Route path="sms" element={<SmsSettings />} />
          <Route path="whatsapp" element={<WhatsappSettings />} />
          <Route path="fms" element={<FmsSettings />} />
          <Route path="docket-series" element={<GlobalDocketSettings />} />
          <Route path="booking-series" element={<GlobalDocketSettings defaultTab="booking" />} />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="role-permissions" element={<RolePermissions />} />
            <Route path="ai" element={<AiSettings />} />
          </Route>
        </Route>
        {/* Estimate routes */}
        <Route path="/estimates" element={<DashboardLayout />}>
          <Route index element={<EstimateList />} />
          <Route path="add" element={<EstimateForm />} />
          <Route path="edit/:id" element={<EstimateForm />} />
        </Route>
        {/* Estimate print (outside layout for clean full-page print) */}
        <Route path="/estimates/print/:id" element={<EstimatePrint />} />
        {/* Trip print (outside layout for clean full-page print) */}
        <Route path="/fleet/trips/print/:id" element={<TripPrint />} />
        {/* AWB Preview (outside layout for full-screen PDF preview) */}
        <Route path="/dockets/:docketId/awb-preview" element={<AWBPreview />} />
        {/* AWB SVG Print (outside layout for clean full-page print) */}
        <Route path="/dockets/:docketId/awb-svg-print" element={<AirWaybillSVGPrint />} />
        {/* Docket Label Print (outside layout for clean thermal print) */}
        <Route path="/dockets/print-label/:id" element={<DocketLabelPrint />} />
        {/* Inventory routes */}
        <Route path="/inventory" element={<DashboardLayout />}>
          <Route index element={<InventoryList />} />
          <Route path="new" element={<InventoryForm />} />
          <Route path="edit/:id" element={<InventoryForm />} />
        </Route>
        {/* Reports routes */}
        <Route path="/reports" element={<DashboardLayout />}>
          <Route index element={<ReportsLanding />} />
          <Route path="inventory" element={<InventoryReports />} />
          <Route path="fleet" element={<FleetReports />} />
          <Route path="dockets" element={<DocketReports />} />
          <Route path="bookings" element={<BookingReports />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
